module.exports = __webpack_public_path__ + "static/img/image_support_video_cover_02.004fb00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_video_cover_02.png
// module id = VbEn
// module chunks = 10